import React, { memo } from 'react';
import Skeleton from './Skeleton';

const OrderDetailsSkeleton = memo(function OrderDetailsSkeleton({ style = {} }) {
  return (
    <div style={{ maxWidth: 1100, margin: '0 auto', padding: '24px 16px', ...style }} aria-busy="true">
      {/* Breadcrumb / Back button */}
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 20 }}>
        <Skeleton variant="rectangular" width={90} height={28} borderRadius={8} />
        <Skeleton variant="text" width={140} height={14} />
      </div>

      {/* Main Content Grid */}
      <div className="grid-1-2" style={{ gridTemplateColumns: '1.2fr 0.8fr', gap: 24, alignItems: 'start' }}>
        {/* Left Column (Image / Product Gallery / Details) */}
        <div style={{ background: '#FFFFFF', borderRadius: 14, border: '1.5px solid var(--border, #E5E7EB)', padding: 24 }}>
          <Skeleton variant="rectangular" width="100%" height={320} borderRadius={12} style={{ marginBottom: 16 }} />
          <div style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
            {Array.from({ length: 4 }).map((_, idx) => (
              <Skeleton key={idx} variant="rectangular" width={60} height={60} borderRadius={8} />
            ))}
          </div>
          <Skeleton variant="text" width="85%" height={24} style={{ marginBottom: 12 }} />
          <Skeleton variant="text" width="40%" height={14} style={{ marginBottom: 16 }} />
          <Skeleton variant="text" width="100%" height={14} style={{ marginBottom: 6 }} />
          <Skeleton variant="text" width="95%" height={14} style={{ marginBottom: 6 }} />
          <Skeleton variant="text" width="70%" height={14} />
        </div>

        {/* Right Column (Sidebar Summary / Pricing / Actions) */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          <div style={{ background: '#FFFFFF', borderRadius: 14, border: '1.5px solid var(--border, #E5E7EB)', padding: 24 }}>
            <Skeleton variant="text" width={100} height={12} style={{ marginBottom: 8 }} />
            <Skeleton variant="text" width={160} height={32} style={{ marginBottom: 16 }} />
            <Skeleton variant="rectangular" width="100%" height={44} borderRadius={9} style={{ marginBottom: 12 }} />
            <Skeleton variant="rectangular" width="100%" height={44} borderRadius={9} />
          </div>

          <div style={{ background: '#FFFFFF', borderRadius: 14, border: '1.5px solid var(--border, #E5E7EB)', padding: 20 }}>
            <Skeleton variant="text" width={140} height={18} style={{ marginBottom: 14 }} />
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
              <Skeleton variant="text" width={90} height={14} />
              <Skeleton variant="text" width={60} height={14} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
              <Skeleton variant="text" width={110} height={14} />
              <Skeleton variant="text" width={80} height={14} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Skeleton variant="text" width={70} height={14} />
              <Skeleton variant="text" width={90} height={14} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default OrderDetailsSkeleton;
